import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import HouseCard from '../houses/HouseCard'
import authServices from '../../services/AuthServices'
import Loading from '../feedback/Loading'

function HouseList() {
    const [properties, setProperties] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        authServices.getProperties('?is_featured=true')
            .then(res => {
                const data = res.data.results || res.data || []
                setProperties(Array.isArray(data) ? data : [])
            })
            .catch(err => console.error('Failed to load featured properties:', err))
            .finally(() => setLoading(false))
    }, [])

    return (
        <div className="max-w-7xl mx-auto space-y-3 px-8 py-16 mb-16">
            <span className="text-xs text-secondary uppercase tracking-widest font-label text-outline mb-2 block">
                Curated Selections
            </span>
            <div className="md:flex md:justify-between">
                <h2 className="text-4xl font-headline text-primary mb-6">
                    Signature Living Spaces
                </h2>
                <div className="hidden md:block">
                    <Link
                        to={'/houses'}
                        className="text-primary font-bold text-sm uppercase tracking-widest border-b border-primary/20 pb-2 hover:border-primary transition-all"
                    >View All Properties</Link>
                </div>
            </div>
            <div>
                {loading ? (
                    <div className="py-10 flex justify-center"><Loading /></div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
                        {properties.length > 0 ? (
                            properties.map(property => (
                                <HouseCard key={property.id} property={property} />
                            ))
                        ) : (
                            <p className="col-span-full text-center text-on-surface-variant/60 py-8">
                                No featured properties available right now.
                            </p>
                        )}
                    </div>
                )}
            </div>
            <div className="flex justify-center md:hidden">
                <Link
                    to={'/houses'}
                    className="text-primary font-bold text-sm uppercase tracking-widest border-b border-primary/20 pb-2 hover:border-primary transition-all"
                >View All Properties</Link>
            </div>
        </div>
    )
}

export default HouseList